<script setup lang="ts">
import { computed } from 'vue'
import { NumberInput } from '@ark-ui/vue'
import UiFieldContainer from './UiFieldContainer.vue'
import UiText from './UiText.vue'

export interface UiCurrencyInputProps {
  name?: string
  id?: string
  placeholder?: string
  currency?: string
  min?: number
  max?: number
  step?: number
  disabled?: boolean
  size?: 'md' | 'lg'
  hint?: string
  error?: string
  invalid?: boolean
}

const props = withDefaults(defineProps<UiCurrencyInputProps>(), {
  currency: 'USD',
  step: 1,
  size: 'md',
})

const model = defineModel<number>({ default: 0 })
const value = computed(() => model.value.toString())
const prefix = computed(() => (props.currency === 'USD' ? '$' : ''))

const emit = defineEmits<{
  (e: 'validate'): void
}>()

function updateModelValue(value: string) {
  model.value = parseFloat(value)
}
</script>

<template>
  <UiFieldContainer :size="props.size" :invalid="props.invalid" :hint="props.hint" :error="props.error" :describedByIdBase="props.id || props.name" :disabled="props.disabled">
    <UiText as="span" variant="span" :class="props.disabled ? 'text-se-gray-400' : 'text-se-gray-700'">{{ prefix }}</UiText>
    <NumberInput.Root :modelValue="value" @update:modelValue="updateModelValue" :min="props.min" :max="props.max" :step="props.step" :disabled="props.disabled">
      <NumberInput.Control>
        <NumberInput.Input :placeholder="props.placeholder" :id="props.id || props.name" :name="props.name" class="flex-1 se-font-input font-archivo" @blur="emit('validate')" />
      </NumberInput.Control>
    </NumberInput.Root>
  </UiFieldContainer>
</template>

